/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the OverviewMetricsResponse interface.
 */
export function instanceOfOverviewMetricsResponse(value) {
    if (!('avgLatencyMs' in value) || value['avgLatencyMs'] === undefined)
        return false;
    if (!('failureRate' in value) || value['failureRate'] === undefined)
        return false;
    if (!('satisfactionRate' in value) || value['satisfactionRate'] === undefined)
        return false;
    if (!('syntheticGenerationsExcluded' in value) || value['syntheticGenerationsExcluded'] === undefined)
        return false;
    if (!('totalCostUsd' in value) || value['totalCostUsd'] === undefined)
        return false;
    if (!('totalDislikes' in value) || value['totalDislikes'] === undefined)
        return false;
    if (!('totalGenerations' in value) || value['totalGenerations'] === undefined)
        return false;
    if (!('totalLikes' in value) || value['totalLikes'] === undefined)
        return false;
    if (!('totalTokensIn' in value) || value['totalTokensIn'] === undefined)
        return false;
    if (!('totalTokensOut' in value) || value['totalTokensOut'] === undefined)
        return false;
    return true;
}
export function OverviewMetricsResponseFromJSON(json) {
    return OverviewMetricsResponseFromJSONTyped(json, false);
}
export function OverviewMetricsResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'avgLatencyMs': json['avgLatencyMs'],
        'failureRate': json['failureRate'],
        'satisfactionRate': json['satisfactionRate'],
        'syntheticGenerationsExcluded': json['syntheticGenerationsExcluded'],
        'totalCostUsd': json['totalCostUsd'],
        'totalDislikes': json['totalDislikes'],
        'totalGenerations': json['totalGenerations'],
        'totalLikes': json['totalLikes'],
        'totalTokensIn': json['totalTokensIn'],
        'totalTokensOut': json['totalTokensOut'],
    };
}
export function OverviewMetricsResponseToJSON(json) {
    return OverviewMetricsResponseToJSONTyped(json, false);
}
export function OverviewMetricsResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'avgLatencyMs': value['avgLatencyMs'],
        'failureRate': value['failureRate'],
        'satisfactionRate': value['satisfactionRate'],
        'syntheticGenerationsExcluded': value['syntheticGenerationsExcluded'],
        'totalCostUsd': value['totalCostUsd'],
        'totalDislikes': value['totalDislikes'],
        'totalGenerations': value['totalGenerations'],
        'totalLikes': value['totalLikes'],
        'totalTokensIn': value['totalTokensIn'],
        'totalTokensOut': value['totalTokensOut'],
    };
}
